<template>
  <MarkdownField
    v-model="context.value.value[props.field.key]"
    v-bind="props"
  />
</template>
<script lang="ts" setup>
import { useFormKitContext } from '@formkit/vue'

import type { SchemaFormKitProps } from '../formkit/types'
import MarkdownField from '../MarkdownField.vue'

const props = defineProps<SchemaFormKitProps>()

const context = useFormKitContext()
</script>
